module.exports = __webpack_public_path__ + "media/images/iconSettings__accent-43f82a4f2ce31f6cf531a78745188ea4.png";